/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState , useRef } from 'react';
import * as Yup from 'yup';
import clsx from 'clsx';
import { Link, useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import { getUserByToken, login } from '../core/_requests';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import { useAuth } from '../core/Auth';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { showToastMessageSuccess, showToastMessageError } from '../../Toast-Message/TosatMessage';
import { useDispatch } from 'react-redux';
import { UserProfileShow } from '../../../../redux/reducers/webData';

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
})

const initialValues = {
  email: '',
  password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const [loading, setLoading] = useState(false);
  const { saveAuth, setCurrentUser } = useAuth();

  const passwordRef = useRef<HTMLInputElement | null>(null);
  const [shoHidePass, setShoHidePass] = useState(false);
  const [passInpuType, setPassInpuType] = useState("password");

  const navigate = useNavigate();

  const dispatch = useDispatch()

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      try {
        const { data: auth } = await login(values.email, values.password)
        dispatch(UserProfileShow(auth.avatar))

        saveAuth(auth)
        const { data: user } = await getUserByToken(auth.api_token)
        setCurrentUser(user)
        navigate("/dashboard");

      } catch (error: any) {
        console.error(error)
        saveAuth(undefined)
        setSubmitting(false)
        setLoading(false)
        console.log((error as any)?.response.data);
        if (error.response && error.response.data) {
          const errorResponse = error.response.data;

          if (errorResponse.data) {
            const fieldErrors = errorResponse.message;
            setStatus(fieldErrors);

            // Object.keys(fieldErrors).forEach((field) => {
            // const errorMessages = fieldErrors[field];
            // const errorMessage = errorMessages[0];

            // setFieldError(field, errorMessage);
            showToastMessageError(fieldErrors);
            // });
          }
        } else {
          // setFieldError('field_name', 'An error occurred.'); // Fallback error message
          showToastMessageError('An error occurred.');
        }
        // setFieldError('field_name', 'message');
        saveAuth(undefined);
        // setStatus(error.response.data.message);
        // setSubmitting(false);
        setLoading(false);
      }
    },
  })

  const showHidePassword = () => {
    setShoHidePass(!shoHidePass);
    if (shoHidePass) {
        setPassInpuType("password");
    } else {
        setPassInpuType("text");
    }
};

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      <ToastContainer />
      <div className='text-center mb-11'>
        <h1 className='text-dark fw-bolder mb-3'>Sign In</h1>
      </div>
      {formik.status ? (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      ) : (
        <div className='mb-10 bg-light-info p-8 rounded d-none'>
          <div className='text-info'>
            Use account <strong>admin@demo.com</strong> and password <strong>demo</strong> to
            continue.
          </div>
        </div>
      )}

      <div className='fv-row mb-8'>
        <label className='form-label fs-6 fw-bolder text-dark'>Email</label>
        <input
          placeholder='Email'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control bg-transparent',
            { 'is-invalid': formik.touched.email && formik.errors.email },
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
          type='email'
          name='email'
          autoComplete='off'
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container text-danger fw-semibold position-absolute'>
            <span role='alert'>{formik.errors.email}</span>
          </div>
        )}
      </div>

      <div className='fv-row mb-3'>
      <label className='form-label fw-bolder text-dark fs-6 mb-0'>Password</label>
        <div className="row me-0">
          <div className="col-11 pe-0">
          <input
          type={passInpuType}
          style={{borderRadius:'0.475rem 0 0 0.475rem'}}
          autoComplete='off'
          placeholder='Password'
          {...formik.getFieldProps('password')}
          className={clsx(
            'form-control bg-transparent',
            {
              'is-invalid': formik.touched.password && formik.errors.password,
            },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
        />
          </div>
          <div className="col-1 d-flex bg-gray-100 align-items-center justify-content-center" style={{border:'1px solid #e3e3e3',borderLeft:'none',borderRadius:'0 0.475rem 0.475rem 0'}}>
          <div onClick={showHidePassword} className='d-flex align-items-center '>
            {shoHidePass ?
                <i className="fa-solid fa-eye text-primary" style={{fontSize:'1.3rem'}}></i> :
                <i className="fa-solid fa-eye-slash" style={{fontSize:'1.3rem'}}></i>}
        </div>
          </div>
        </div>
        
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container text-danger fw-semibold position-absolute'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>

      <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>
        <div />
        <Link to='/auth/forgot-password' className='link-primary'>
          Forgot Password ?
        </Link>
      </div>

      <div className='d-grid mb-10'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-primary'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>Continue</span>}
          {loading && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>

      <div className='text-gray-500 text-center fw-semibold fs-6'>
        Not a Member yet?{' '}
        <Link to='/auth/registration' className='link-primary'>
          Sign up
        </Link>
      </div>
    </form>
  );
}
